import AbstractApi from '@/api/abstracts/AbstractApi'
// eslint-disable-next-line prettier/prettier
import TimesheetsEntryApi from '@/api/services/timesheets/entry/TimesheetsEntryApi'
import TimesheetsApprovalApi from '@/api/services/timesheets/approval/TimesheetsApprovalApi'

/**
 * @property string apiEnd /api/timesheets
 */
export default class TimesheetsApi extends AbstractApi {
  entry(): TimesheetsEntryApi {
    return new TimesheetsEntryApi(`${this.apiEnd}/entry`)
  }

  approval(): TimesheetsApprovalApi {
    return new TimesheetsApprovalApi(`${this.apiEnd}/approval`)
  }
}
